var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlancFondBleu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0063E5;}\n\t.st1{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 500,
    height: 500
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_sigle_e-delivery"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    className: "st1",
    d: "M250,500c0.2-138,112-249.8,250-250v89.7c-88.5,0-160.2,71.7-160.2,160.2c0,0,0,0,0,0 l0,0H250z M0.5,409.5c88.5-0.1,160.2-71.8,160.2-160.2h88.2C250,111.9,361.5,1.1,498.9,0.9v89.8c-88.5,0.1-160.2,71.8-160.2,160.2 h-88.2c-1,137.4-112.6,248.3-250,248.4L0.5,409.5z M0,160.2C88.5,160.2,160.2,88.5,160.2,0h89.8C249.9,138,138,249.9,0,250V160.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlancFondBleu);
export default __webpack_public_path__ + "static/media/logo_blanc_fond_bleu.e12a4b2a.svg";
export { ForwardRef as ReactComponent };